import { render } from "./2SliderOffer.vue?vue&type=template&id=05ad0774&scoped=true"
import script from "./2SliderOffer.vue?vue&type=script&lang=js"
export * from "./2SliderOffer.vue?vue&type=script&lang=js"

import "./2SliderOffer.vue?vue&type=style&index=0&id=05ad0774&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ad0774"]])

export default __exports__